<script lang="ts">
    import MedialibImage from "../../../widgets/MedialibImage.svelte"
    import MoreButton from "../../../widgets/MoreButton.svelte"
    let {
        section,
    }: {
        section: NavSectionContent
    } = $props()
</script>

<div class="image-nav-card">
    <div class="background-image">
        <MedialibImage id={section.primary_image[0]} maxWidth={400} />
    </div>
    <div class="content">
        <h2 class="title">{section.primary_link_title}</h2>
        <h3 class="description">
            {section.primary_link_description}
        </h3>
        <MoreButton text={section.primary_link_text} page_ref={section.primary_link} type="white" />
    </div>
</div>

<style lang="less" global>
    @import "../../../../css/variables.less";
    .image-nav-card {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        height: 480px;

        .background-image {
            position: relative;
            height: 100%;
            width: 100%;

            picture,
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 4px;
            }
        }
        .content {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 2.4rem;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            border-radius: 4px;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%);
            h2 {
                color: var(--bright-100);
                margin-bottom: 0.3rem;
            }
            h3 {
                color: var(--bright-100);
                margin-bottom: 0.5rem;
            }
        }
        @media @max-mobile-header {
            height: fit-content;
            .background-image {
                position: absolute;
                height: 100%;
                width: 100%;
            }
            .content {
                padding: 1.2rem;
                position: relative;
                h2 {
                    font-size: 1.8rem;
                }
                h3 {
                    font-size: 1rem;
                }
            }
        }
    }
</style>
